import { Container, Row, Col } from 'react-bootstrap'
import Layout from 'components/Layout/Layout'
import UspPageTitle from 'components/UspPageTitle/UspPageTitle'
import { withOpenAccessPage } from '@srca-b2b/kp5-ui-common/utils/auth'
import styles from './eula.module.scss'

const EulaKPEOnPrem = () => {
  return (
    <Layout>
      <Container>
        <UspPageTitle title="terms and conditions" />
        <Row className={styles.termsAndConditionsWrapper}>
          <Col sm={12}>
            <h2 className={styles.header}>
              Knox Platform for Enterprise (On-Premise) End User License Agreement for Enterprise
            </h2>
            <div className={styles.customListContent}>
              <p>
                This Knox Platform for Enterprise (On-Premise) End User License Agreement for
                Enterprise ("EULA" or this “Agreement”) is a binding contract between you and
                Samsung Electronics Co., Ltd. (“Samsung”) which governs your use of Knox Platform
                for Enterprise and services provided therewith (collectively, the “Software”).
              </p>
              <p>
                PLEASE READ THIS AGREEMENT CAREFULLY BEFORE ACCESSING OR USING THE SOFTWARE BECAUSE
                IT CONSTITUTES A BINDING LEGAL AGREEMENT BETWEEN YOU AND SAMSUNG. IF YOU ARE AN
                EMPLOYEE OF OR CONSULTANT OR CONTRACTOR TO AN ENTITY SUBSCRIBING TO THE SOFTWARE
                (“CUSTOMER”), YOUR AGREEMENT TO THIS EULA WILL BE DEEMED TO BE THE AGREEMENT BETWEEN
                THAT CUSTOMER AND SAMSUNG AND YOU AND THE CUSTOMER REPRESENT AND WARRANT THAT YOU
                HAVE AUTHORITY OR HAVE BEEN PROVIDED THE AUTHORITY TO BIND THE CUSTOMER TO THE TERMS
                AND CONDITIONS OF THIS EULA.
              </p>
              <p>
                BY ACCESSING OR USING THE SOFTWARE, CUSTOMER ACKNOWLEDGES THAT CUSTOMER HAS READ AND
                UNDERSTOOD THIS AGREEMENT, AND CUSTOMER AGREES TO COMPLY WITH AND BE BOUND BY ITS
                TERMS. IF CUSTOMER IS NOT WILLING TO BE BOUND BY THE TERMS OF THIS AGREEMENT,
                CUSTOMER MAY NOT ACCESS OR USE THE SOFTWARE.
              </p>
              <p>
                NOTWITHSTANDING ANYTHING ELSE STATED HEREIN, IF CUSTOMER AND SAMSUNG HAVE EXECUTED A
                WRITTEN AGREEMENT FOR THE ACCESS TO OR USE OF THE SOFTWARE (“SIGNED AGREEMENT”),
                THEN THE TERMS OF THE SIGNED AGREEMENT SHALL GOVERN AND CONTROL AND THIS AGREEMENT
                SHALL HAVE NO EFFECT.
              </p>
              <p>
                CUSTOMER ACKNOWLEDGES THAT CUSTOMER REPRESENTATIVE (AS DEFINED BELOW) MAY NEED TO
                ACCEPT ADDITIONAL TERMS AND CONDITIONS THAT MAY POP UP ON THE SCREEN OF HIS OR HER
                MOBILE DEVICE WHICH RELATE TO DATA COLLECTION, PRIVACY PRACTICES, FUNCTIONING OF THE
                SOFTWARE AND SAMSUNG’S LIABILITY DIRECTLY TO CUSTOMER REPRESENTATIVES (“POP UP
                AGREEMENT”) TO ACCESS TO OR USE THE SOFTWARE. IN THE EVENT OF A CONFLICT BETWEEN THE
                TERMS OF THE POP UP AGREEMENT AND THIS EULA, THIS EULA SHALL GOVERN AND CONTROL AND
                THE CONFLICTING TERMS OF THE POP UP AGREEMENT SHALL HAVE NO EFFECT TO CUSTOMER OR
                CUSTOMER REPRESENTATIVE.
              </p>
              <p>
                This EULA includes the following attachments which are incorporated herein by
                reference:
              </p>
              <p>A. Local Terms &amp; Conditions (as applicable)</p>
              <ol start="1" type="1">
                <li>LICENSE</li>
                <ul>
                  <li>1.1 Grant of License</li>
                  <p>
                    Subject to the terms and conditions of this EULA, during the applicable license
                    term, Samsung hereby grants to Customer, and any employee or contractor of
                    Customer whom Customer authorizes to access and use the Software on behalf of
                    and for the benefit of Customer (“Customer Representative”) a limited,
                    non-exclusive, non-transferable and non-sublicensable license for Customer and
                    Customer Representatives to use the object code form of the Software for
                    Customer’s purposes only and , solely in accordance with the applicable
                    documentation provided by Samsung for use of the Software (“Documentation”).
                    Customer may use the Documentation for internal purposes only. Customer may not
                    use the Software for any purpose or in any way, not expressly permitted by this
                    EULA. The Software is licensed, not sold. All references to the Software
                    includes all related graphics, user interfaces, scripts and services provided by
                    Samsung for use of the Software, and any updates, upgrades, enhancements,
                    modifications, revisions or additions to the Software made available to Customer
                    by Samsung. However, Samsung is under no obligation to provide any updates,
                    upgrades, enhancements, modifications, revisions or additions to the Software
                    except if Customer has purchased maintenance services from Samsung or a Samsung
                    Knox authorized reseller.
                  </p>
                  <li>1.2 Restrictions</li>
                  <p>
                    As a condition of the license granted in Section 1.1, Customer shall not: (i)
                    use the Software or any portion thereof, except as expressly authorized by this
                    EULA; (ii) use the Software or any portion thereof on equipment, products, or
                    systems not identified in Documentation; (iii) modify the Software or any
                    portion thereof or create derivative works based upon any Software or any
                    portion thereof; (iv) reverse engineer or decompile, decrypt, disassemble or
                    otherwise reduce the Software or any portion thereof to human-readable form; (v)
                    use the Software or any portion thereof in any way that is in violation of any
                    applicable laws; (vi) distribute, sell, license or otherwise provide the
                    Software or any portion thereof to any third parties; (vii) use the Software or
                    any portion thereof to perform services for third parties except as otherwise
                    expressly provided herein; (vii) release, publish, and/or otherwise make
                    available to any third party the results of any performance, functional or
                    security evaluation of the Software or any portion thereof without the prior
                    written approval of Samsung; (viii) alter or remove any proprietary notices or
                    legends contained on or in the Software or any portion thereof; or (ix) use the
                    Software for emergency, life saving, life support, nuclear energy equipment, air
                    traffic control, the operation of critical communication system, public
                    transportation control or other ultra-hazardous uses where failure of the
                    Software to perform would be reasonably expected to cause deaths, injuries or
                    severe physical property or environmental losses. Any attempt to do any of the
                    foregoing shall be deemed as a material breach under this Agreement.
                  </p>
                </ul>
                <li>INTELLECTUAL PROPERTY, LICENSES</li>
                <ul>
                  <li>2.1 Ownership</li>
                  <p>
                    The Software is proprietary to Samsung or its licensors, and protected under
                    applicable copyright, patent, trademark and trade secret laws. Customer further
                    acknowledges and agrees that, as between Customer and Samsung, Samsung owns and
                    shall continue to own all right, title and interest in and to the Software,
                    including associated intellectual property rights under the applicable laws.
                    This EULA does not grant Customer any ownership interest in or to the Software,
                    but only a limited license to use that is revocable in accordance with the terms
                    of this EULA.
                  </p>
                  <li>2.2 Open Source Software</li>
                  <p>
                    The Software may contain or be provided with open source libraries, components,
                    utilities and other open source software (collectively, “Open Source”), which
                    Open Source may have applicable license terms as identified on a website
                    designated by Samsung or otherwise provided with the applicable Documentation.
                    Notwithstanding anything to the contrary herein, use of the Open Source shall be
                    subject to the applicable Open Source license terms and conditions to the extent
                    required by the applicable licensor (which terms shall not restrict the license
                    rights granted to Customer hereunder but may contain additional rights).
                  </p>
                </ul>
                <li>SPECIAL PROVISION: USE OF SAMSUNG Knox CONTAINER</li>
                <ul>
                  <li>3.1 Container</li>
                  <p>
                    The Software provides additional security by creating a separate Samsung Knox
                    Container (“Container”), which is designed to isolate Customer’s or Customer
                    Representative’s data and applications from certain attacks including data
                    leakage, malware &amp; malicious attacks such as vicious virus infection
                    (“Malicious Attacks”). (For further information, please visit:
                    http://www.samsungknox.com)
                  </p>

                  <li>3.2 Third Party Applications</li>
                  <p>
                    Samsung will not be responsible for any failure of performance, deterioration,
                    or malfunction of third party applications that may be downloaded, included in,
                    or installed in the Container. Samsung will not be responsible if such
                    applications do not effectively isolate data within the container or protect
                    against Malicious Attacks. Because Samsung has no control over such third party
                    applications, Customer acknowledges and agrees that Samsung is not responsible
                    for the availability of such third party applications and is not responsible or
                    liable for any content, advertising, products, services, or other materials on
                    or available through the third party applications. Customer expressly
                    acknowledges and agrees that use of third party applications is at Customer’s
                    sole risk and that the entire risk of unsatisfactory quality, performance,
                    accuracy and effort is with Customer. It is up to Customer to take precautions
                    to ensure that whatever Customer selects to use is free of such items as
                    viruses, worms, Trojan horses, and other items of a destructive nature.
                    References to any names, marks, products, or services of any third parties are
                    provided solely as a convenience to Customer, and do not constitute or imply an
                    endorsement, sponsorship, or recommendation of, or affiliation with the third
                    party or its products and services. Customer agrees that Samsung shall not be
                    responsible or liable, directly or indirectly, for any damage or loss, including
                    but not limited to any damage to the mobile device or loss of data, caused or
                    alleged to be caused by, or in connection with, use of or reliance on any such
                    third party content, products, or services available on or through any such
                    third party application. Customer acknowledges and agrees that the use of any
                    third party application is governed by such third party provider’s terms of use,
                    license agreement, privacy policy, or other such agreement and that any
                    information or personal data Customer provides, whether knowingly or
                    unknowingly, to such third party application provider, will be subject to such
                    third party privacy policy, if such a policy exists.
                  </p>
                  <p>
                    SAMSUNG DISCLAIMS ANY RESPONSIBILITY FOR ANY DISCLOSURE OF INFORMATION OR ANY
                    OTHER PRACTICES OF ANY THIRD PARTY APPLICATION PROVIDER. SAMSUNG EXPRESSLY
                    DISCLAIMS ANY WARRANTY REGARDING WHETHER CUSTOMER’S PERSONAL INFORMATION IS
                    CAPTURED BY ANY THIRD PARTY APPLICATION PROVIDER OR THE USE TO WHICH SUCH
                    PERSONAL INFORMATION MAY BE PUT BY SUCH THIRD PARTY APPLICATION PROVIDER.
                  </p>
                  <li>3.3 Trusted Boot</li>
                  <p>
                    Software provides a security feature, called Trusted Boot, which is designed to
                    detect unauthorized rooting and custom ROM (i.e., to detect non-Samsung-official
                    firmware), which may have been installed in Customer’s or Customer
                    Representative’s device during booting time. Upon detection of such unauthorized
                    rooting or custom ROM, the Container will be automatically locked and Customer
                    or Customer Representative may not use the data or application stored or
                    installed in the Container.&nbsp;
                    <em>
                      <u>
                        Thus, Customer and Customer Representative are strongly advised to back up
                        important data or information as set forth in Section 3.4.
                      </u>
                    </em>
                  </p>
                  <li>3.4 Back-Up</li>
                  <p>
                    Customer and Customer Representative may not pull out the data or information
                    stored in the Container. Customer and Customer Representative are strongly
                    advised to back-up any data and information before storing or using them in the
                    Container. Samsung shall not be liable for any loss of data or information
                    arising from Customer’s or Customer Representative’s failure to back-up.
                  </p>
                </ul>
                <li>SUPPORT AND MAINTENANCE SERVICES</li>
                <p>
                  Support and Maintenance Services (“Maintenance Service”) may be delivered by
                  Samsung in accordance with Samsung’s Support Services for Knox Products Policy
                  at&nbsp;
                  <a href="https://www.samsungknox.com/en/support-services-for-knox-products">
                    https://www.samsungknox.com/en/support-services-for-knox-products
                  </a>
                  &nbsp;(“Samsung’s Support Policy”), which may be changed from time to time by
                  Samsung’s sole discretion. If Samsung provides Maintenance Services to Customer on
                  behalf of a Samsung Knox authorized reseller (“Authorized Reseller”), Samsung’s
                  Support Policy will be applicable. If Customer has paid an Authorized Reseller the
                  relevant fees to obtain support and/or maintenance services directly from such
                  Authorized Reseller, Customer should contact such Authorized Reseller for such
                  support and/or maintenance and relevant sections under this EULA and Samsung’s
                  Support Policy shall not apply.
                </p>
                <li>License Management</li>
                <ul>
                  <li>
                    5.1 For Customer's internal management of the Software license and to help
                    ensure that Customer's use of the Software fully complies with the terms and
                    conditions of this Agreement, Customer shall install the license management
                    software ("On-premise Agent") as provided by Samsung in its own server and use
                    the On-premise Agent to manage the validation and activation of the Software.
                  </li>
                  <li>
                    5.2 Subject to the terms and conditions of this Agreement, during the applicable
                    license term, Samsung hereby grants to Customer a limited, non-exclusive,
                    non-transferable and non-sublicensable license to use the object code form of
                    the On-premise Agent, solely in accordance with the relevant documentation
                    provided by Samsung, and for the sole purpose of performing its obligation under
                    the Section 5.1. Section 1.2 (Restrictions) shall apply with respect to
                    Customer's use of the One-premise Agent.
                  </li>
                  <li>
                    5.3 Customer acknowledges that Customer may have to collect personally
                    identifiable information from Customer Representative in using the On-premise
                    Agent to manage the validation and activation of the Software and agree that
                    Customer has the sole responsibility for complying with applicable privacy and
                    data protection laws and regulations in using the On-premise Agent. Customer
                    hereby warrants that it will comply with all applicable privacy and data
                    protection laws in using the On-premise Agent.
                  </li>
                </ul>
                <li>TERM; TERMINATION</li>
                <ul>
                  <li>6.1 Term</li>
                  <p>
                    The license granted herein with respect to the Software shall remain effective
                    until terminated or until the applicable license term expires, whichever is
                    earlier. This EULA is entered into as of the earlier of the date that Customer
                    accepts the terms herein or first accesses or uses any Software (the “Effective
                    Date”).
                  </p>
                  <li>6.2 Termination by Samsung</li>
                  <p>
                    If Customer fails to comply with any of the provisions of this EULA, without
                    limiting Samsung's other rights and remedies, all of which are expressly
                    reserved, at its sole discretion, Samsung may provide Customer written notice of
                    breach and if Customer fails to cure within thirty (30) days of such notice,
                    Samsung may immediately discontinue Customer’s and Customer Representative’s
                    access to the Software and terminate this EULA. Upon termination of this EULA,
                    Customer and Customer Representative shall cease use of all Software in its
                    possession or control. Section 9 and 10 and all liabilities that accrue prior to
                    termination or expiration shall survive any termination or expiration of this
                    EULA.
                  </p>
                </ul>
                <li>LIMITED WARRANTIES; DISCLAIMER</li>
                <ul>
                  <li>7.1 Limited Warranties</li>
                  <p>
                    For a period of ninety (90) days from the date of initial delivery of the
                    Software to Customer, Samsung warrants that such Software materially conforms to
                    the specifications described in the relevant Documentation. Customer’s sole and
                    exclusive remedy and the entire liability of Samsung and its licensors under
                    this limited warranty will be, at Samsung’s option, repair or replacement of
                    such Software, or if repair or replacement is not possible, to refund the
                    license and any associated support and maintenance fees paid for such
                    non-conforming Software upon the return and removal (as applicable) of all such
                    Software from servers and devices. Samsung represents and warrants to Customer
                    that Maintenance Services, if provided by Samsung, shall be professional,
                    workmanlike and performed in a manner conforming to generally accepted industry
                    standards and practices for similar services. Samsung’s entire liability and
                    Customer’s sole and exclusive remedy for any breach of the preceding warranty
                    for Maintenance Services will be for Samsung to re-perform the nonconforming
                    services, provided that Samsung must have received written notice of the
                    non-conformity from Customer no later than ninety (90) days after the original
                    delivery of the services by Samsung. The express warranties specified above do
                    not apply if the Software or any portion of the foregoing: (i) has been altered,
                    except by Samsung; (ii) has not been used, installed, operated, repaired, or
                    maintained in accordance with this EULA and/or Documentation; (iii) has been
                    subjected to abnormal physical or electrical stress, misuse, negligence, or
                    accident; or (iv) is used on equipment, products, or systems not meeting
                    specifications identified by Samsung in the applicable Documentation.
                    Additionally, the warranties set forth herein only apply when notice of a
                    warranty claim is provided to Samsung within the applicable warranty period
                    specified herein and do not apply to any bug, defect or error caused by or
                    attributable to software or hardware not supplied by Samsung.
                  </p>
                  <li>7.2 Disclaimer</li>
                  <p>
                    EXCEPT FOR THE WARRANTIES EXPRESSLY SET FORTH IN THIS SECTION 7, THE SOFTWARE IS
                    PROVIDED “AS IS”, "WHERE IS" AND “AS AVAILABLE” AND WITHOUT WARRANTIES OF ANY
                    KIND. SAMSUNG AND ITS LICENSORS MAKE NO REPRESENTATIONS OR WARRANTIES OR
                    GUARANTEES OF ANY KIND OR NATURE, WHETHER EXPRESS OR IMPLIED, REGARDING THE
                    SOFTWARE, AND SPECIFICALLY DISCLAIMS ALL SUCH WARRANTIES, INCLUDING WITHOUT
                    LIMITATION ANY IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                    PURPOSE AND NONINFRINGEMENT. WITHOUT LIMITING THE PREVIOUS DISCLAIMER, SAMSUNG
                    AND ITS LICENSORS DO NOT REPRESENT, WARRANT OR GUARANTEE THAT THE SOFTWARE WILL
                    (i) OPERATE IN AN UNINTERRUPTED, TIMELY, SECURE OR ERROR-FREE MANNER, (ii) WILL
                    ALWAYS BE AVAILABLE OR FREE FROM ALL HARMFUL COMPONENTS OR ERRORS OR (iii) WILL
                    BE SECURE OR IMMUNE (INCLUDING THE CONTENT DELIVERED TO CUSTOMER OR THE
                    INFORMATION CUSTOMER PROVIDED) FROM UNAUTHORIZED ACCESS OR MALICIOUS ATTACKS.
                  </p>
                </ul>
                <li>LIMITATION OF LIABILITY</li>
                <p>
                  TO THE EXTENT PERMITTED BY LAW, IN NO EVENT SHALL SAMSUNG OR ITS LICENSORS BE
                  LIABLE TO CUSTOMER FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL,
                  EXEMPLARY, PUNITIVE DAMAGES OR LOST PROFITS, EVEN IF SAMSUNG HAS BEEN ADVISED OF
                  THE POSSIBILITY OF SUCH DAMAGES. IN NO EVENT SHALL THE AGGREGATE LIABILITY OF
                  SAMSUNG ARISING OUT OF OR RELATED TO THIS AGREEMENT, INCLUDING WITHOUT LIMITATION,
                  THE USE OF OR INABILITY TO USE SOFTWARE, ASSOCIATED SERVICES, OR OTHERWISE, EXCEED
                  THE FEES CUSTOMER PAID FOR THE SOFTWARE OR MAINTENANCE SERVICE. THIS LIMITATION
                  WILL APPLY REGARDLESS OF THE THEORY OF LIABILITY, WHETHER BREACH OF CONTRACT,
                  NEGLIGENCE, INFRINGEMENT OR ANY OTHER THEORY REGARDLESS OF WHETHER OR NOT SAMSUNG
                  HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THIS LIMITATION AND WAIVER
                  ALSO APPLIES TO ANY CLAIMS CUSTOMER MAY BRING AGAINST ANY OTHER PARTY TO THE
                  EXTENT THAT SAMSUNG WOULD BE REQUIRED TO INDEMNIFY THAT PARTY FOR SUCH CLAIM.
                  MULTIPLE CLAIMS SHALL NOT EXPAND THE LIMITATIONS SET FORTH IN THIS SECTION.
                </p>
                <li>CONFIDENTIALITY</li>
                <p>
                  The Software (and any performance data, benchmark results, security assessments
                  and all other technical information relating to the Software), the Documentation,
                  the terms and conditions of this EULA and any other information provided by
                  Samsung in connection with the Software shall be deemed the confidential
                  information of Samsung (“Confidential Information”). Notwithstanding the
                  foregoing, Confidential Information shall not include information that Customer
                  can evidence in writing: (a) is already known to Customer without restriction as
                  to disclosure prior to disclosure by Samsung; (b) becomes publicly available
                  without fault of Customer; (c) is rightfully obtained by Customer from a third
                  party without restriction as to disclosure; or (d) is independently developed or
                  created by Customer without use of the Confidential Information. Except as
                  otherwise expressly authorized herein, Customer agrees to: (i) use the
                  Confidential Information only to perform hereunder or exercise rights granted to
                  it hereunder; (ii) treat all Confidential Information in the same manner as it
                  treats its own similar proprietary information, but in no case will the degree of
                  care be less than reasonable care; and (iii) disclose the Confidential Information
                  only to Customer’s employees and agents who have a need to know such information
                  for the purposes of this EULA, provided that any such employee or agent shall be
                  subject to obligations of non-use and confidentiality with respect to the
                  Confidential Information at least as restrictive as the terms of this EULA, and
                  Customer shall remain liable for any non-compliance of such employee or agent with
                  the terms of this EULA. Nothing in this EULA shall prevent Customer from
                  disclosing information to the extent Customer is legally compelled to do so by any
                  governmental investigative or judicial agency pursuant to proceedings over which
                  such agency has jurisdiction; provided, however, that prior to any such
                  disclosure, Customer shall: (i) assert the confidential nature of the information
                  to the agency, (ii) immediately notify Samsung in writing of the agency’s order or
                  request to disclose, and (iii) cooperate fully with Samsung in protecting against
                  any such disclosure and obtaining a protective order narrowing the scope of the
                  compelled disclosure and protecting its confidentiality. The confidentiality
                  obligations under this Section shall survive any expiration or termination of this
                  EULA and be effective for a period of three (3) years after the expiration or
                  termination of this EULA
                </p>
                <li>GENERAL TERMS</li>
                <ul>
                  <li>10.1 Choice of Law</li>
                  <p>
                    Except as otherwise set forth in Attachment A (if applicable), of this EULA,
                    including all revisions and amendments thereto, is governed by and construed in
                    accordance with the laws of the Republic of Korea, without regard to its
                    conflict or choice of law principles. Notwithstanding any choice of law
                    provision or otherwise, and the United States Uniform Computer Information
                    Transactions Act the United Nations Convention on the International Sale of
                    Goods shall not apply.
                  </p>
                  <li>10.2 Arbitration</li>
                  <p>
                    Except as otherwise set forth in Attachment A (if applicable), , Customer
                    unconditionally consents and agrees that: (i) any claim, dispute or controversy
                    (whether in contract, tort, or otherwise) Customer may have against Samsung or
                    its officers, directors, agents and employees arising out of, relating to, or
                    connected in any way with the Software or this EULA (including its existence,
                    validity or termination), will be finally resolved by arbitration to be held in
                    Seoul, Korea and conducted in English under the Rules of Arbitration of the
                    International Chamber of Commerce provided, however, that each party may enforce
                    its or its Affiliates’ (defined below) intellectual property rights in any court
                    of competent jurisdiction, including but not limited to equitable relief. The
                    arbitral award shall be final and binding on the parties. Except to the extent
                    entry of judgment and any subsequent enforcement may require disclosure, all
                    matters relating to the arbitration, including the award, shall be held in
                    confidence. For purposes of this EULA, Affiliate means, any corporation or other
                    entity that is controlled by, or is under common control with a party (a
                    corporation or other entity shall be deemed to control another if it owns or
                    controls more than fifty percent (50%) of the voting stock or other ownership
                    interest of the corporation or entity).
                  </p>
                  <li>10.3 Independent Contractors</li>
                  <p>
                    The parties are independent contractors, and this EULA shall not establish any
                    relationship of partnership, joint venture, employment, franchise or agency
                    between the parties.
                  </p>
                  <li>10.4 Equitable Relief</li>
                  <p>
                    The parties agree that a material breach of this EULA would cause irreparable
                    injury to Samsung for which there may be no adequate remedy at law. Accordingly,
                    Samsung shall have the right to apply to any court of competent jurisdiction for
                    injunctive relief and specific performance, without prejudice to any remedies
                    available to it at law or in equity.
                  </p>
                  <li>10.5 Entire EULA; Modifications</li>
                  <p>
                    This EULA constitutes the entire agreement between the parties with respect to
                    the provision of the Software and Maintenance Services. This EULA supersedes and
                    cancels all previous written and previous or contemporaneous oral
                    communications, proposals, representations, and agreements relating to the
                    subject matter contained herein. This EULA prevails over any pre-printed,
                    conflicting or additional terms of any purchase order, ordering document,
                    acknowledgement or confirmation or other document issued by Customer, even
                    accepted in writing by both parties.
                  </p>
                  <li>10.6 Export</li>
                  <p>
                    Software and Documentation, including any technical data provided by Samsung
                    hereunder, may be subject to export, re-export or import control laws under the
                    country of origin, destination or use, including regulations under such laws.
                    Customer shall comply fully with all international and national laws and
                    regulations that apply to the Software and Documentation and to Customer and
                    Customer Representative’s use thereof, including, but not limited to, the U.S.
                    Export Administration Regulations, end-user, end-use and destination
                    restrictions issued by U.S. and other governments. Without limiting the
                    generality of the foregoing, Customer expressly agrees that Customer shall not,
                    and shall cause Customer Representative to agree not to, export, directly or
                    indirectly, re-export, divert, or transfer the Software and Documentation or any
                    technical data thereof to any destination, company or person restricted or
                    prohibited by U.S. laws or regulations or laws or regulations of any other
                    applicable jurisdiction. Customer represents and warrants that (i) Customer is
                    not located in a country that is subject to a U.S. Government embargo, or that
                    has been designated by the U.S. Government as a “terrorist supporting” country;
                    and (ii) Customer are not listed on any U.S. Government list of prohibited or
                    restricted parties.
                  </p>
                  <li>10.7 Severability</li>
                  <p>
                    If any term or provision of this EULA is held to be void or unenforceable by any
                    judicial or administrative authority, such determination shall not affect the
                    validity of enforceability of the remaining terms and provisions of this EULA.
                    The remaining provisions of this EULA shall remain in effect and shall be
                    construed in accordance with its terms.
                  </p>
                  <li>10.8 Headings</li>
                  <p>
                    The headings contained in this EULA are for reference purposes only and shall
                    not affect the meaning or interpretation of this EULA.
                  </p>
                  <li>10.9 No Waiver</li>
                  <p>
                    The failure of Samsung to enforce at any time any of the provisions of this
                    EULA, or the failure by Samsung to require at any time performance by Customer
                    of any of the provisions of this EULA, shall in no way be construed to be a
                    present or future waiver of such provisions, nor in any way affect the right of
                    Samsung to enforce such provision thereafter. The express waiver by Samsung of
                    any provision, condition or requirement of this EULA shall not constitute a
                    waiver of any future obligation to comply with such provision, condition or
                    requirement.
                  </p>
                  <li>10.10 U.S. Government End User Purchasers</li>
                  <p>
                    All Software, including all components thereof, and Documentation qualify as
                    “commercial items,” as that term is defined at Federal Acquisition Regulation
                    (“FAR”) (48 C.F.R.) 2.101, consisting of “commercial computer software” and
                    “commercial computer software documentation” as such terms are used in FAR
                    12.212. Consistent with FAR 12.212 and DoD FAR Supp. 227.7202-1 through
                    227.7202-4, and notwithstanding any other FAR or other contractual clause to the
                    contrary in any agreement into which this EULA may be incorporated, Customer may
                    provide to Government end user or, if this EULA is direct, Government end user
                    will acquire, the Software and Documentation with only those rights set forth in
                    this EULA. Use of either the Software or Documentation or both constitutes
                    agreement by the Government that all Software and Documentation are “commercial
                    computer software” and “commercial computer software documentation,” and
                    constitutes acceptance of the rights and restrictions herein.
                  </p>
                  <li>10.11 Notice</li>
                  <p>
                    Any notice required or permitted to be given in accordance with this EULA shall
                    be in writing. Notices to Samsung shall be sent by personal delivery, registered
                    or certified mail (return receipt requested, postage prepaid) or commercial
                    express courier (with written verification of receipt) to:
                  </p>
                  <p>Samsung Co., Ltd.</p>
                  <p>(Maetan dong) 129, Samsung-ro, Yeongtong-gu,</p>
                  <p>Suwon-si, Gyeonggo-do 443-742 Korea</p>
                  <p>Attention: General Counsel.</p>
                  <p>
                    For contractual purposes, Customer consents to receive communications from
                    Samsung electronically. Notices sent to Customer shall be sent by personal
                    delivery, electronic mail, registered or certified mail (return receipt
                    requested, postage prepaid) or commercial express courier (with written
                    verification of receipt) to: the electronic address Customer have provided to
                    Samsung or its Authorized Reseller in connection with licensing Software or
                    invoicing. All notices will be deemed given: (i) when delivered personally; (ii)
                    24 hours after electronic mail is sent, unless Samsung is notified that the
                    email address is invalid; (iii) five (5) days after having been sent by
                    registered or certified mail, (or ten (10) days for international mail); or (iv)
                    one (1) day after deposit with a commercial express courier specifying next day
                    delivery (or two (2) days for international courier packages specifying 2-day
                    delivery). Customer or Samsung may change its address for receipt of notice by
                    notice to the other in accordance with this Section.
                  </p>
                </ul>
              </ol>
              <p>ATTACHMENT A</p>
              <p>LOCAL TERMS AND CONDITIONS – United States of America</p>
              <p>
                The following terms apply to Customer with its principal offices within United
                States of America or is a resident of the United States of America or to the extent
                that the laws of the United States of America apply to Customer’s use of the
                Software.
              </p>
              <p>
                This Agreement and Customer’s relationship with Samsung shall be governed and
                construed in accordance with the laws of the state of Texas, without regard to its
                conflict of law provisions. Subject to Samsung’s right to seek injunctive remedies
                (or an equivalent type of urgent legal relief) in any jurisdiction, Customer
                unconditionally consents and agrees that: (1) any claim, dispute, or controversy
                (whether in contract, tort, or otherwise) Customer may have against Samsung or the
                officers, directors and employees of Samsung and its subsidiaries or Affiliates (all
                such individuals and entities collectively referred to herein as the “Samsung
                Entities”) arising out of, relating to, or connected in any way with the Software or
                this EULA (including its existence, validity or termination) or the determination of
                the scope or applicability of this agreement to arbitrate, will be resolved
                exclusively by final and binding arbitration administered by JAMS or another
                mutually-acceptable alternative dispute resolution provider ("Arbitration Tribunal")
                and conducted in the United States before a sole arbitrator in accordance with the
                rules of the Arbitration Tribunal; (2) this arbitration agreement is made pursuant
                to a transaction involving interstate commerce in the United States, and shall be
                governed by the Federal Arbitration Act (“FAA”), 9 U.S.C. §§ 1-16; (3) the
                arbitrator’s decision shall be controlled by this Agreement and any of the other
                agreements referenced herein that the applicable Customer may have entered into in
                connection with the Software; (4) the arbitrator shall honor claims of privilege
                recognized at law; (5) there shall be no authority for any claims to be arbitrated
                on a class or representative basis, arbitration can decide only Customer’s and/or
                the applicable Samsung Entity’s individual claims; the arbitrator may not
                consolidate or join the claims of other persons or parties who may be similarly
                situated; (6) the arbitrator shall not have the power to award punitive, exemplary,
                special or consequential damages against Customer or any Samsung Entity; (7) in the
                event that the administrative fees and deposits that must be paid to initiate
                arbitration against any Samsung Entity exceed $125 USD, and Customer is unable (or
                not required under the rules of the Arbitration Tribunal) to pay any fees and
                deposits that exceed this amount, Samsung agrees to pay them and/or forward them on
                Customer’s behalf, subject to ultimate allocation by the arbitrator. In addition, if
                Customer is able to demonstrate that the costs of arbitration will be prohibitive as
                compared to the costs of litigation, Samsung will pay as much of Customer’s filing
                and hearing fees in connection with the arbitration as the arbitrator deems
                necessary to prevent the arbitration from being cost-prohibitive; and (8) with the
                exception of subparts (5) and (6) above, if any part of this arbitration provision
                is deemed to be invalid, unenforceable or illegal, or otherwise conflicts with the
                rules of the Arbitration Tribunal, then the balance of this arbitration provision
                shall remain in effect and shall be construed in accordance with its terms as if the
                invalid, unenforceable, illegal or conflicting provision were not contained herein.
                If, however, subpart (5) or subpart (6) is found to be invalid, unenforceable or
                illegal, then if Samsung so elects, the entirety of this arbitration provision shall
                be null and void, and neither Customer nor Samsung shall be entitled to arbitrate
                their dispute.
              </p>
              <p>LOCAL TERMS AND CONDITIONS - Europe</p>
              <p>
                The following terms apply to any Customer with its principal offices or residence
                within the European Economic Area (EEA) or European Union, or Switzerland, Iceland,
                Montenegro, Serbia, Kosovo, Albania, Bosnia &amp; Herzegovina, Macedonia, San
                Marino, Monaco, Vatican City, the Channel Islands, the Isle of Man, overseas
                departments of France, or the Faeroe Islands:
              </p>
              <ul>
                <li>
                  1. Despite paragraph 10.1 of this Agreement, this Agreement and Customer’s
                  relationship with Samsung shall be subject to the laws and jurisdiction of the
                  state listed above in which you have your principal offices or, if you are not a
                  business, the state listed above where you are resident.
                </li>
                <li>
                  2. Despite any term of this Agreement in paragraph 1.2 or elsewhere to the
                  contrary, and to the extent required by Directive 91/250/EEC (as amended) on the
                  legal protection of computer programs as implemented in your jurisdiction, for the
                  time while you have the right to use the Software you have the right to:
                </li>
                <li>
                  2.1 make a back-up copy to the extent that it is necessary to do so to use the
                  Software;
                </li>
                <li>
                  2.2 observe, study or test the functioning of the Software in order to determine
                  the ideas and principles which underlie any element of the program if you do so
                  while performing any of the acts of loading, displaying, running, transmitting or
                  storing the program which you are entitled to do; and
                </li>
                <li>
                  2.3 disassemble, decompile, reverse engineer or create derivative works based on
                  the whole, or any part, of the Software but in either case only to the extent that
                  such actions cannot be prohibited because they are essential for the purpose of
                  achieving inter-operability of the Software with another software program, and
                  provided that the information obtained by you during such activities: (i) is used
                  only for the purpose of achieving inter-operability of the Software with another
                  software program (ii) is not unnecessarily disclosed or communicated to any third
                  party without the Samsung’s prior written consent; and (iii) is not used to
                  develop, produce or market any software which is substantially similar to the
                  Software or for any other act which infringes copyright.
                </li>
                <li>
                  3. Nothing in this EULA (in particular paragraphs 7 and 8) shall exclude or limit,
                  or be taken as seeking to exclude or limit, any liability which the applicable law
                  does not permit to be excluded, or, as the case may be, limited but only to the
                  extent that such exclusion or limitation is not permitted or would make the EULA
                  unenforceable. Depending on the applicable law, this may include willful
                  misconduct, gross negligence, death or injury caused by negligence, fraud,
                  fraudulent misrepresentation or warranties as to ownership which cannot be
                  excluded by law.
                </li>
                <li>
                  4. Despite paragraph 10.2, the place of Arbitration shall be London, England.
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export const getServerSideProps = withOpenAccessPage(async ({ loggedInUser }) => {
  const props = {}
  if (loggedInUser) {
    props.loggedInUser = loggedInUser
  }
  return {
    props
  }
})
export default EulaKPEOnPrem
